import React from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';
import { tryFetchHuggingAIResponse } from '../../others/hugging';

const MessageParser = ({ children, actions }) => {
  const parse = async (message) => {
    console.log(message);

    actions.handleUserMessage({
      text: message,
      originalMessage: message,
    });

    return {
      text: message,
      originalMessage: message,
    }
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;